import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import inView from 'in-view';
import './juxtapose';

import MapComp from './Map';
import core from '~/core/scripts';
import LocatorMaps from './locatormap';
import { isIE11, isIE } from '~/core/scripts/utils';

import './styles/index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

const useFallback = isIE11 || isIE;
const mapSelectorId = useFallback ? 'map__fallback' : 'map';

if (useFallback) {
  document.body.classList.add('is-fallback');
}

ReactDOM.render(<MapComp />, document.getElementById(mapSelectorId));

init();
LocatorMaps.init();

function init() {
  inView('.lazy-jux').on('enter', handleLazyJux);
}

function handleLazyJux(elm) {
  const $elm = $(elm);

  if (!$elm.hasClass('juxtapose-loaded')) {
    createSlider($elm);

    $elm
      .addClass('juxtapose-loaded')
      .parents('.juxtapose-wrapper')
      .append(
        $('<div />')
          .addClass('calltoaction')
          .html(
            '<img src="images/slider/hand-slider.svg" /><span class="calltoaction-text callToAction">Verschieben</span>'
          )
      );
  }
}

function createSlider($elm) {
  new window.juxtapose.JXSlider(
    `#${$elm.attr('id')}`,
    [
      {
        src: $elm.attr('data-left-image'),
        label: $elm.attr('data-left-label')
      },
      {
        src: $elm.attr('data-right-image'),
        label: $elm.attr('data-right-label')
      }
    ],
    {
      animate: false,
      showLabels: true,
      showCredits: false,
      startingPosition: $elm.parents('.content-box').attr('data-startpos') || '50%'
    }
  );
}

if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!./index.html');
}
